<template>
  <div class="login uk-container uk-width-1-2">
    <form @submit.prevent="login" class="uk-panel uk-panel-box uk-form">
      <div class="uk-margin">
        <input v-model="username" class="uk-width-1-1 uk-form-large" type="email" placeholder="User Name">
      </div>
      <div class="uk-margin">
        <input v-model="password" class="uk-width-1-1 uk-form-large" type="password" placeholder="Password">
      </div>
      <div class="uk-margin">
        <button class="uk-width-1-1 uk-button uk-button-secondary uk-button-large">ログイン</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    login () {
      this.$cognito.login(this.username, this.password)
        .then(result => {
          this.$router.replace('/home')
        })
        .then(err => {
          this.error = err
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue